import { observer } from "mobx-react";
import { SelectOption } from "~/types";
import languageStore, { LangId, LanguageInfo } from "~/stores/language";
import { useEffect } from "react";
import AsyncPaginatedCombobox from "~/components/AsyncPaginatedCombobox";

interface Props {
  value: LangId[];
  onChange: (newValue: LangId[]) => void;
  selectProps?: any;
  className?: string;
  filter?: (item: LanguageInfo) => boolean;
}

const LanguageSelect = observer((props: Props) => {
  const filter = props.filter ?? (() => true);
  const options: SelectOption[] = Object.values(languageStore.loadedLanguages)
    .filter(filter)
    .map((lang) => ({
      value: lang.id,
      label: lang.text,
    }));
  const itemIdToOption = (id: LangId) => {
    const lang = languageStore.loadedLanguages[id];
    if (!lang) return null;
    return { value: id, label: lang.text };
  };
  useEffect(() => {
    languageStore.loadLanguages();
  }, []);
  return (
    <AsyncPaginatedCombobox
      options={options}
      itemIdToOption={itemIdToOption as any}
      value={props.value}
      onChange={props.onChange as any}
      selectProps={{ isMulti: true, ...(props.selectProps || {}) }}
    />
  );
});

export default LanguageSelect;
